import { useMemo } from 'react';

import {
  useOfferUpdateMutation,
  useConstraintCreateMutation,
  useConstraintDeleteMutation,
  useEarningMechanismCreateMutation,
  useEarningMechanismDeleteMutation,
  useLimitCreateMutation,
  useLimitDeleteMutation,
  useMarketingContentUpdateMutation,
  useMarketingContentCreateMutation,
  useOfferCreateMutation,
  useOfferDisplayCategoriesCreateOrUpdateMutation,
  useLimitUpdateMutation,
  useConstraintUpdateMutation,
  useEarningMechanismUpdateMutation,
  useStoredValueProgramCreateMutation,
  useStoredValueProgramUpdateMutation,
  usePromocodeBatchCreateMutation,
  usePromocodeBatchUpdateMutation,
  usePromocodeBatchDeleteMutation,
  usePromoCodesUploadProcessMutation,
} from '@occc/graphql';

export type IUseGetOfferOperationHandlersReturns = ReturnType<typeof useGetOfferOperationHandlers>;

// return functions for handling operations
export const useGetOfferOperationHandlers = () => {
  const [offerCreate] = useOfferCreateMutation();
  const [offerUpdate] = useOfferUpdateMutation();
  const [limitCreate] = useLimitCreateMutation();
  const [constraintCreate] = useConstraintCreateMutation();
  const [constraintUpdate] = useConstraintUpdateMutation();
  const [limitDelete] = useLimitDeleteMutation();
  const [limitUpdate] = useLimitUpdateMutation();
  const [constraintDelete] = useConstraintDeleteMutation();
  const [earningMechanismCreate] = useEarningMechanismCreateMutation();
  const [earningMechanismDelete] = useEarningMechanismDeleteMutation();
  const [earningMechanismUpdate] = useEarningMechanismUpdateMutation();
  const [marketingContentCreate] = useMarketingContentCreateMutation();
  const [marketingContentUpdate] = useMarketingContentUpdateMutation();
  const [offerDisplayCategoriesCreateOrUpdate] = useOfferDisplayCategoriesCreateOrUpdateMutation();
  const [promocodeBatchCreate] = usePromocodeBatchCreateMutation();
  const [promocodeBatchUpdate] = usePromocodeBatchUpdateMutation();
  const [promocodeBatchDelete] = usePromocodeBatchDeleteMutation();
  const [promoCodesUploadProcess] = usePromoCodesUploadProcessMutation();
  const [storedValueProgramCreate] = useStoredValueProgramCreateMutation();
  const [storedValueProgramUpdate] = useStoredValueProgramUpdateMutation();

  const handlers = useMemo(
    () => ({
      offerCreate,
      offerUpdate,
      earningMechanismCreate,
      earningMechanismDelete,
      earningMechanismUpdate,
      limitCreate,
      limitUpdate,
      limitDelete,
      constraintCreate,
      constraintUpdate,
      constraintDelete,
      marketingContentCreate,
      marketingContentUpdate,
      offerDisplayCategoriesCreateOrUpdate,
      promocodeBatchCreate,
      promocodeBatchUpdate,
      promocodeBatchDelete,
      promoCodesUploadProcess,
      storedValueProgramCreate,
      storedValueProgramUpdate,
    }),
    [
      offerCreate,
      offerUpdate,
      constraintCreate,
      constraintUpdate,
      constraintDelete,
      earningMechanismCreate,
      earningMechanismDelete,
      earningMechanismUpdate,
      limitCreate,
      limitUpdate,
      limitDelete,
      marketingContentCreate,
      marketingContentUpdate,
      offerDisplayCategoriesCreateOrUpdate,
      promocodeBatchCreate,
      promocodeBatchUpdate,
      promocodeBatchDelete,
      promoCodesUploadProcess,
      storedValueProgramCreate,
      storedValueProgramUpdate,
    ],
  );

  return handlers;
};
